import React from "react";
import { Card, Table, Typography } from "antd";

export default function BreakdownTable({ data, offices }) {
  //Test data
  // const data = {total_users: 2,   task_completed: 2,   
  //   steps: [  {    name: "root canal0",   exact: 0,   cumulative: 10000,   percent: 100       },   
  //         {    name: 'Booking canal',      exact: 2,      cumulative: 7500,      percent: 75       },   
  //         {    name: ' canal',      exact: 2,      cumulative: 5000,      percent: 50       },   
  //         {    name: ' canal',      exact: 2,      cumulative: 3000,      percent: 30       },   
  //       ] 
  //     } 
  if (!data || !data.steps || data.steps.length === 0) return null;

  const formatter = new Intl.NumberFormat("en-US");

  const first = data.steps[0].cumulative;

  const breakdown = data.steps.map((step, index) => {
    const current = step.cumulative;
    const next =
      index < data.steps.length - 1 ? data.steps[index + 1].cumulative : null;

    let dropOff = "-";
    let dropOffRate = "-";

    if (next !== null) {
      dropOff = current - next;
      dropOffRate = current
        ? Math.round(((current - next) / current) * 100) + "%"
        : "-";
    }

    const conversionRate = first
      ? Math.round((current / first) * 100) + "%"
      : "0%";

    return {
      key: index,
      step: index + 1,
      stepName: step.name,
      users: formatter.format(current),
      dropOff: dropOff === "-" ? "-" : formatter.format(dropOff),
      conversionRate,
      dropOffRate,
    };
  });


  const columns = [
    { title: "Step", dataIndex: "step", key: "step", 
      render: (text) => <span style={{color: '#6b43b5'}}>{text}</span>, 
    },
    { title: "Step Name", dataIndex: "stepName", key: "stepName" },
    { title: "Users Reached", dataIndex: "users", key: "users", align: "center"  },
    {
      title: "Drop-off",
      dataIndex: "dropOff",
      key: "dropOff",
      align: "center",
      render: (text) => (
        text !== "-" ? (
          <span style={{ color: text !== "-0" ? "#D4183D" : "inherit" }}>
            {`-${text}`}
          </span>
        ) : "-"
      ),
    },
    {
      title: "Conversion Rate",
      dataIndex: "conversionRate",
      key: "conversionRate",
      align: "center",
      render: (text) =>
        <span  
          style={{
            background: "#dcfce7",
            color: "oklch(0.448 0.119 151.328)",
            padding: "3.5px 12px",
            borderRadius: "14px",
            display: "inline-block",
          }}
        >
          {text}
        </span>
    },
    {
      title: "Drop-off Rate",
      dataIndex: "dropOffRate",
      key: "dropOffRate",
      align: "center",
      render: (text) => (
        text !== "-" ? (
          <span 
            style={{ 
              background: 'oklch(0.936 0.032 17.717)',
              color: text !== "0%" ? "oklch(0.444 0.177 26.899)" : "inherit" ,
              padding: "3.5px 12px",
              borderRadius: "14px",
              display: "inline-block",
            }}
          >
            {`-${text}`}
          </span>
        ): "-"
      ),
    },
  ];

  return (
    <Card>
      <Typography.Title
        level={5}
        style={{ marginBottom: 12 }}
      >
        Step-by-Step Breakdown
      </Typography.Title>
      <Typography.Text type="secondary" style={{ marginBottom: 16, display: "block" }}>
        Comprehensive analysis of patient progression through each step
      </Typography.Text>
      {offices && offices.length === 0 ? 
        <Typography>Please, select at least one office.</Typography>
      :
        <Table
          dataSource={breakdown}
          columns={columns}
          pagination={false}
          bordered={false}
        />
      }

    </Card>
  );
}
